export default __webpack_public_path__ + "static/media/content-mission.a60f22f1.svg";